enum MembershipTypes {
  CCO = 'cco',
  CIO = 'cio',
  ATK = 'atk',
  COOKBOOK_COLLECTION = 'cookbook_collection',
  INSTRUCTOR_ACCESS = 'instructor_access',
  COOKING_SCHOOL = 'school',
  SCHOOL_ESCOFFIER = 'escoffier_school',
  SCHOOL_ESCOFFIER_INSTRUCTOR = 'escoffier_instructor_access',
  CLASSES = 'classes',
}

export default MembershipTypes;
